import {
  MarketingEmailsInput,
  MarketingEmailsOutput,
} from "@/interfaces/marketing-emails";

import { BaseService } from "./BaseService";

export class MarketingEmailsService extends BaseService<
  MarketingEmailsInput,
  MarketingEmailsOutput
> {
  constructor() {
    super();
    this.path = "marketing_emails";
  }
}
